import SortAlphAsc from './SortAlphAsc'

export default SortAlphAsc
// eslint-disable-next-line import/export
export * from './SortAlphAsc'
